import { useState } from 'react';

import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

import { Button } from '../Button';

export type CollapsableTextProps = {
  children: string;
  previewMaxLength: number;
  maxHeight?: string;
  onCollapse?: (open: boolean) => void;
};

export const CollapsableText: React.FC<CollapsableTextProps> = ({ children: _children, previewMaxLength, maxHeight, onCollapse }) => {
  const children = _children || '';
  const collapsable = children.length > previewMaxLength;
  const [ open, setOpen ] = useState(!collapsable);
  const { classes } = useCollapsableTextStyles();

  const text = children.slice(0, open ? children.length : previewMaxLength).concat(open ? '' : '...');
  const buttonText = open ? 'Read Less' : 'Read More';

  const handleCollapse = () => {
    setOpen(!open);
    onCollapse?.(!open);
  };

  return (
    <Box>
      <Typography style={{ maxHeight: maxHeight }} className={classes.text}>{text}</Typography>
      {collapsable && (
        <Box mt={0.5}>
          <Button
            onClick={handleCollapse}
            color="inherit"
            fullWidth
          >
            {buttonText}&nbsp;&nbsp;{open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
          </Button>
        </Box>
      )}
    </Box>
  );
};

const useCollapsableTextStyles = makeStyles({ name: 'CollapsableText' })(() => ({
  text: {
    whiteSpace: 'pre-wrap',
    overflowY: 'auto'
  },
}));
